// extracted by mini-css-extract-plugin
module.exports = {"label":"Form_label__N-rCg","tip":"Form_tip__1SrBx"};